import { Close } from '@mui/icons-material'
import {
  Alert,
  Button,
  Container,
  Dialog,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material'
import { Formik } from 'formik'
import OTPInput, { ResendOTP } from 'otp-input-react'
import * as Yup from 'yup'
import { useState } from 'react'

function EditMobileDialog({
  visibility,
  onClose,
  onSubmit,
  showOtpUI,
  onResendOTP,
  onBackClick
}) {
  const [OTP, setOTP] = useState('')

  let validationSchema = {}
  validationSchema = Yup.object().shape({
    mobile: Yup.string().min(10, 'Min 10 digits').required('Required')
  })
  const handleSubmit = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting }
  ) => {
    if (!showOtpUI) setOTP('')
    else values.OTP = OTP
    onSubmit(values)
  }

  const handleResendOTP = (mobile) => {
    setOTP('')
    onResendOTP(mobile)
  }
  return (
    <>
      <Dialog
        maxWidth="xs"
        open={visibility}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          Edit Mobile Number
          <IconButton
            component="span"
            size="small"
            sx={{ ':hover': { backgroundColor: 'red', color: 'white' } }}
            onClick={onClose}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Container>
          <Formik
            initialValues={{
              mobile: '',
              submit: false
            }}
            validationSchema={!showOtpUI && validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                {errors.submit && (
                  <Alert mt={2} mb={1} severity="warning">
                    {errors.submit}
                  </Alert>
                )}
                <Grid container>
                  <Grid item md>
                    <TextField
                      margin="dense"
                      size="small"
                      name="mobile"
                      label="New Mobile"
                      error={Boolean(touched.mobile && errors.mobile)}
                      fullWidth
                      helperText={touched.mobile && errors.mobile}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      disabled={showOtpUI}
                      my={3}
                    />
                  </Grid>
                </Grid>
                {showOtpUI && (
                  <div sx={{ marginTop: 5 }}>
                    <Divider sx={{ marginTop: 5, marginBottom: 1 }} />
                    <Typography gutterBottom component="h2" variant="body1">
                      OTP Verification
                    </Typography>
                    <OTPInput
                      value={OTP}
                      onChange={setOTP}
                      autoFocus
                      OTPLength={4}
                      otpType="number"
                      disabled={false}
                    />
                    <ResendOTP
                      onResendClick={() => handleResendOTP(values.mobile)}
                    />
                  </div>
                )}
                <Grid
                  container
                  justifyContent="flex-end"
                  style={{ paddingTop: 10, paddingBottom: 20 }}
                >
                  {!showOtpUI && (
                    <Grid item>
                      <Button
                        fullWidth
                        type="submit"
                        size="small"
                        variant="outlined"
                        color="primary"
                        disabled={isSubmitting}
                      >
                        Send OTP
                      </Button>
                    </Grid>
                  )}
                  {showOtpUI && (
                    <Grid item sx={{ paddingRight: 3 }}>
                      <Button
                        type="submit"
                        size="small"
                        variant="outlined"
                        color="success"
                        disabled={isSubmitting}
                        onClick={onBackClick}
                      >
                        Back
                      </Button>
                    </Grid>
                  )}
                  {showOtpUI && (
                    <Grid item>
                      <Button
                        type="submit"
                        fullWidth
                        size="small"
                        variant="outlined"
                        color="primary"
                        disabled={isSubmitting}
                      >
                        Verify & Update
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </form>
            )}
          </Formik>
        </Container>
      </Dialog>
    </>
  )
}

export default EditMobileDialog
